import { Route, Routes } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Asm from "./pages/Asm";
import Dri from "./pages/Dri";
import Compliance from "./pages/Compliance";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import FreeScan from "./pages/FreeScan";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/asm" element={<Asm />} />
        <Route path="/dri" element={<Dri />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/free-scan" element={<FreeScan />} />
      </Route>
    </Routes>
  );
}
